module.exports = __webpack_public_path__ + "img/pending-actions-black-24-dp-1.a9f28bd1.svg";